
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"90","height":"125","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.138 124.337c-8.275-12.436-2.545-21.789 2.057-29.306 4.264-6.961 6.308-10.863 2.437-16.646-3.873-5.783-9.516-7.258-19.99-9.568-11.303-2.493-25.498-5.46-33.567-17.828C2.883 38.755 8.613 29.4 13.218 21.885c4.265-6.96 6.309-10.862 2.438-16.643-3.875-5.785-9.52-7.256-20.103-9.44-11.188-2.615-25.258-5.717-33.449-17.95-8.19-12.233-2.541-21.502 2.143-29.101 4.264-6.96 6.309-10.862 2.438-16.643-3.872-5.783-9.516-7.256-19.985-9.564-11.305-2.492-25.378-5.593-33.567-17.826-8.19-12.232-2.46-21.585 2.146-29.099 4.265-6.96 6.39-10.825 2.438-16.643l20.509-6.474c8.188 12.231 2.458 21.585-2.147 29.099-4.265 6.959-6.309 10.861-2.44 16.641 3.876 5.787 9.522 7.257 19.986 9.563 11.306 2.494 25.378 5.596 33.567 17.826 8.19 12.233 2.461 21.586-2.258 29.224-4.15 6.838-6.278 10.828-2.151 16.598 3.704 5.71 9.349 7.18 19.813 9.487 11.308 2.493 25.376 5.594 33.566 17.825 8.191 12.233 2.462 21.586-2.002 29.164-4.405 6.899-6.4 10.823-2.578 16.583 3.872 5.785 9.518 7.259 19.99 9.568 11.304 2.491 25.375 5.596 33.51 17.89 8.249 12.173 2.519 21.526-2.084 29.043-4.263 6.961-6.308 10.863-2.436 16.646l-20.424 6.678z","fill":"#CE5640"}})])
          )
        }
      }
    